// frontend/src/components/auth/register/registerValidation.ts

import * as yup from "yup";
import { translations } from "./registerTranslations";
import { isValidBrazilianPhone } from "../../../utils/phoneFormatter";

export const getValidationSchemas = (lang: string): yup.ObjectSchema<Record<string, unknown>>[] => {
  const t = translations[lang]?.validations || translations.pt.validations;

  return [
    yup.object({
      fullName: yup
        .string()
        .min(5, t.fullNameMin)
        .required(t.fullNameRequired),
      email: yup
        .string()
        .email(t.emailInvalid)
        .required(t.emailRequired),
      password: yup
        .string()
        .min(8, t.passwordMin)
        .required(t.passwordRequired),
      confirmPassword: yup
        .string()
        .oneOf([yup.ref("password")], t.passwordsMustMatch)
        .required(t.confirmPasswordRequired),
    }),
    yup.object({
      projectName: yup
        .string()
        .min(3, t.projectNameMin)
        .required(t.projectNameRequired),
      phone: yup
        .string()
        .test('phone-validation', t.phoneInvalid, function(value) {
          if (!value) return false;
          return isValidBrazilianPhone(value);
        })
        .required(t.phoneRequired),
      website: yup
        .string()
        .url(t.websiteInvalid)
        .nullable(),
    }),
  ] as yup.ObjectSchema<Record<string, unknown>>[];
};
